import React from 'react'
import authRoute from './authRoute'
import pagesRoute from './pagesRoute'
import { withoutAuthRoute } from './withoutAuthRoute'

export const publicRoutes = [...authRoute]

export const protectedRoutes = [
    {
        key: 'home',
        path: '/home',
        component: React.lazy(() => import('views/Home')),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management',
        component: React.lazy(
            () => import('views/social-house-management/SocialHouseInfo/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management/create-case/:orgId',
        component: React.lazy(
            () => import('views/social-house-management/Case/Edit/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management/case/edit/:caseId',
        component: React.lazy(
            () => import('views/social-house-management/Case/Edit/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management/case/:caseId',
        component: React.lazy(
            () => import('views/social-house-management/Case/Detail/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management/create-match/:caseId',
        component: React.lazy(
            () => import('views/social-house-management/Match/Edit/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management/match/:matchId',
        component: React.lazy(
            () => import('views/social-house-management/Match/Detail/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management/match/edit/:matchId',
        component: React.lazy(
            () => import('views/social-house-management/Match/Edit/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management/match/document-management/:matchId',
        component: React.lazy(
            () => import('views/social-house-management/Match/Document/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement',
        path: '/social-house-management/match/document-management/:matchId/edit/:contractId',
        component: React.lazy(
            () =>
                import(
                    'views/social-house-management/Match/Contract/Edit/index'
                )
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement.matchList',
        path: '/social-house-management/match-list',
        component: React.lazy(
            () => import('views/social-house-management/Match/List/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement.inventoryLessors',
        path: '/social-house-management/inventory-lessors',
        component: React.lazy(
            () =>
                import('views/social-house-management/Inventory/lessors/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement.inventoryTenants',
        path: '/social-house-management/inventory-tenants',
        component: React.lazy(
            () =>
                import('views/social-house-management/Inventory/tenants/index')
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'socialHouseManagement.inventoryCompanies',
        path: '/social-house-management/inventory-companies',
        component: React.lazy(
            () =>
                import(
                    'views/social-house-management/Inventory/companies/index'
                )
        ),
        authority: [],
        enable_funcs: ['affordable_house'],
    },
    {
        key: 'houseManagement',
        path: '/house-management',
        component: React.lazy(
            () => import('views/house-management/HouseList/index')
        ),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'houseManagement',
        path: '/house-management/create-house/:orgId',
        component: React.lazy(
            () => import('views/house-management/HouseDetailsEdit/index')
        ),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'houseManagement.details',
        path: `/house-management/details/:houseId`,
        component: React.lazy(
            () => import('views/house-management/HouseDetails/index')
        ),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'houseManagement.details.edit',
        path: `/house-management/details/:houseId/edit`,
        component: React.lazy(
            () => import('views/house-management/HouseDetailsEdit/index')
        ),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.awaitRentContract',
        path: '/await-rent-contract',
        component: React.lazy(() => import('views/contract/AwaitRentContract')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.awaitVerifyContract',
        path: '/await-verify-contract',
        component: React.lazy(
            () => import('views/contract/AwaitVerifyContract')
        ),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.expiringContract',
        path: '/expiring-contract',
        component: React.lazy(() => import('views/contract/ExpiringContract')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.ongoingContract',
        path: '/ongoing-contract',
        component: React.lazy(() => import('views/contract/OngoingContract')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.renewingContract',
        path: '/renewing-contract',
        component: React.lazy(() => import('views/contract/RenewingContract')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.expiredContract',
        path: '/expired-contract',
        component: React.lazy(() => import('views/contract/ExpiredContract')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.archivedContract',
        path: '/archived-contract',
        component: React.lazy(() => import('views/contract/ArchivedContract')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.earnestContract',
        path: '/earnest-contract',
        component: React.lazy(() => import('views/contract/EarnestContract')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.createContract',
        path: '/create-contract/:id',
        component: React.lazy(() => import('views/create-contract')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.details',
        path: `/contract-management/details/:contractId`,
        component: React.lazy(() => import('views/contract/ContractDetail')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'contractManagement.scheduleRentBills',
        path: `/contract-management/schedule-rent-bills/:contractId`,
        component: React.lazy(() => import('views/contract/ScheduleRentBills')),
        authority: ['org:houses:list'],
        enable_funcs: [],
    },
    {
        key: 'houseAccountManagement.bills',
        path: '/house-account-management/bills',
        component: React.lazy(() => import('views/house-account-management')),
        authority: ['org:bills:list'],
        enable_funcs: [],
    },
    {
        key: 'houseAccountManagement.expenses',
        path: '/house-account-management/expenses',
        component: React.lazy(
            () => import('views/house-account-management-expenses')
        ),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'houseAccountManagement.expensesDetail',
        path: '/house-account-management/expenses/detail/:id',
        component: React.lazy(
            () => import('views/house-account-management-expenses-detail')
        ),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'houseAccountManagement.createExpenses',
        path: '/house-account-management/create-expenses/:createOriginHouseId',
        component: React.lazy(
            () => import('views/house-account-management-expenses-detail')
        ),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'repairManagement.maintenanceRecord',
        path: '/repair-management/maintenance-record',
        component: React.lazy(() => import('views/repair-record')),
        authority: ['repair-record:list'],
        enable_funcs: [],
    },
    {
        key: 'repairManagement.workOrderManagement',
        path: '/repair-management/work-order-management',
        component: React.lazy(() => import('views/work-order-management')),
        authority: ['repair-record:list'],
        enable_funcs: [],
        meta: {
            header: '工單管理',
        },
    },
    {
        key: 'repairManagement.workOrderDetail',
        path: '/repair-management/work-order-detail/:orgId/:workOrderId',
        component: React.lazy(() => import('views/work-order-detail')),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'repairManagement.createWorkOrder',
        path: '/repair-management/create-work-order/:orgId',
        component: React.lazy(() => import('views/create-work-order')),
        authority: ['repair-record:list'],
        enable_funcs: [],
    },
    {
        key: 'repairManagement.maintenanceSupplier',
        path: '/repair-management/maintenance-supplier',
        component: React.lazy(() => import('views/maintenance-supplier')),
        authority: ['repair-record:list'],
        enable_funcs: [],
        meta: {
            header: '維修供應商',
        },
    },
    // TODO: 業主管理功能 S15 再開啟
    // {
    //     key: 'propertyOwnersManagement.propertyOwnersList',
    //     path: '/property-owners-management/property-owners-list',
    //     component: React.lazy(() => import('views/property-owners-list')),
    //     authority: [],
    //     enable_funcs: [],
    //     meta: {
    //         header: '業主列表',
    //     },
    // },
    // {
    //     key: 'propertyOwnersManagement.propertyOwnerDetail',
    //     path: '/property-owners-management/property-owner-detail/:orgId/:propertyOwnerId',
    //     component: React.lazy(() => import('views/property-owners-detail')),
    //     authority: [],
    //     enable_funcs: [],
    // },

    {
        key: 'houseAccountManagement.details',
        path: '/house-account-management/details/:accountId',
        component: React.lazy(() => import('views/house-account-details')),
        authority: ['org:bills:list'],
        enable_funcs: [],
    },
    {
        key: 'organizationManagement.memberManagement',
        path: '/member-management',
        component: React.lazy(() => import('views/member-management')),
        authority: [],
        meta: {
            header: '組織成員',
        },
        enable_funcs: [],
    },
    {
        key: 'organizationManagement.walletWithdrawal',
        path: '/wallet',

        component: React.lazy(() => import('views/wallet')),
        authority: ['org:edit'],
        enable_funcs: [],
        meta: {
            header: '提領中心',
            headerContainer: false,
        },
    },
    {
        key: 'organizationManagement.walletWithdrawalDetail',
        path: '/wallet-detail/:id',
        component: React.lazy(() => import('views/wallet-detail')),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'organizationManagement.customerWebsiteSetting',
        path: '/customer-website-setting',
        component: React.lazy(() => import('views/customer-website-setting')),
        authority: [],
        enable_funcs: ['customer_website'],
    },
    {
        key: 'organizationManagement.withdrawalRecord',
        path: '/withdrawal-record',
        component: React.lazy(() => import('views/house-account-management')),
        authority: ['org:bills:list'],
        enable_funcs: [],
    },
    {
        key: 'organizationManagement.walletSettings',
        path: '/wallet-settings',
        component: React.lazy(() => import('views/house-account-management')),
        authority: ['org:bills:list'],
        enable_funcs: [],
    },
    {
        key: 'organizationManagement.walletSettings',
        path: '/wallet-settings',
        component: React.lazy(() => import('views/house-account-management')),
        authority: ['org:bills:list'],
        enable_funcs: [],
    },

    /** Example purpose only */
    {
        key: 'singleMenuItem',
        path: '/single-menu-view',
        component: React.lazy(() => import('views/demo/SingleMenuView')),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'collapseMenu.item1',
        path: '/collapse-menu-item-view-1',
        component: React.lazy(() => import('views/demo/CollapseMenuItemView1')),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'collapseMenu.item2',
        path: '/collapse-menu-item-view-2',
        component: React.lazy(() => import('views/demo/CollapseMenuItemView2')),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'groupMenu.single',
        path: '/group-single-menu-item-view',
        component: React.lazy(
            () => import('views/demo/GroupSingleMenuItemView')
        ),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'groupMenu.collapse.item1',
        path: '/group-collapse-menu-item-view-1',
        component: React.lazy(
            () => import('views/demo/GroupCollapseMenuItemView1')
        ),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'groupMenu.collapse.item2',
        path: '/group-collapse-menu-item-view-2',
        component: React.lazy(
            () => import('views/demo/GroupCollapseMenuItemView2')
        ),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'handover/manage-scenes',
        path: '/handover/manage-scenes/:contractId',
        component: React.lazy(() => import('views/handover/ManageScenes')),
        authority: [],
        enable_funcs: [],
        meta: {
            header: '點交確認書',
            extraHeader: React.lazy(
                () =>
                    import('views/handover/ManageScenes/components/PanelHeader')
            ),
            headerContainer: true,
        },
    },
    {
        key: 'handover/edit-scenes',
        path: '/handover/edit-scenes',
        component: React.lazy(() => import('views/handover/EditScenes')),
        authority: [],
        enable_funcs: [],
    },
    {
        key: 'iotDevicesManagement',
        path: '/iot-devices-management',
        component: React.lazy(() => import('views/iot-devices-management')),
        authority: [],
        enable_funcs: [],
        meta: {
            header: '設備管理',
            extraHeader: React.lazy(
                () =>
                    import(
                        'views/iot-devices-management/components/PanelHeader'
                    )
            ),
            headerContainer: true,
        },
    },
    {
        key: 'iotDevicesManagement.details',
        path: '/iot-devices-management/details/:iotId',
        component: React.lazy(
            () => import('views/iot-devices-management-details')
        ),
        authority: [],
        enable_funcs: [],
    },
    ...pagesRoute,
]

export const withoutAuthRoutes = [...withoutAuthRoute]
